import { FC } from "react";
import Select from "react-select";

import { ISelectCarmaProps } from "./types";
import CustomOption from "./Components/CustomOption/CustomOption";

import '../../assets/css/library/react-select.css'; 



const SelectCarma: FC<ISelectCarmaProps> = (props) => {
  return (
    <div className="select">
      <Select
        components={{ Option: CustomOption }}
        classNamePrefix="select"
        hideSelectedOptions
        isSearchable={false}
        {...props}
      />
    </div>
  );
}

export default SelectCarma;
